import { isPlatformBrowser, NgOptimizedImage } from "@angular/common";
import { AfterViewInit, Component, ElementRef, inject, input, OnDestroy, PLATFORM_ID, ViewChild } from "@angular/core";
import { TranslocoPipe } from "@jsverse/transloco";
import EmblaCarousel, { EmblaCarouselType, EmblaPluginType } from "embla-carousel";
import Autoplay from "embla-carousel-autoplay";
import Fade from "embla-carousel-fade";
import { GetDirectusImagePipe } from "../../../../../../common/pipes/get-directus-image.pipe";
import { Files } from "../../../../../api/packbo/models/files";
import { ItemsAds } from "../../../../../api/packbo/models/items-ads";

export enum AdCarouselType {
    SQUARE_AD = "square_ad",
    VERTICAL_AD = "vertical_ad",
    HORIZONTAL_AD = "horizontal_ad",
    TARGETED_HORIZONTAL_AD = "targeted_horizontal_ad"
}

@Component({
    selector: "packbo-ad-carousel",
    templateUrl: "./ad-carousel.template.html",
    imports: [GetDirectusImagePipe, NgOptimizedImage, TranslocoPipe]
})
export class AdCarouselComponent implements AfterViewInit, OnDestroy {
    @ViewChild("emblaViewport", { static: false }) emblaViewport!: ElementRef<HTMLElement>;

    public readonly ads = input.required<(ItemsAds & { image: Files })[]>();
    public readonly carouselType = input.required<AdCarouselType>();

    public readonly AdCarouselType = AdCarouselType;
    private emblaCarouselType?: EmblaCarouselType;
    private readonly platformId = inject(PLATFORM_ID);

    public ngAfterViewInit(): void {
        if (isPlatformBrowser(this.platformId) && this.emblaViewport && this.emblaViewport.nativeElement) {
            const userPlugins: EmblaPluginType[] = [];

            if (
                this.carouselType() === AdCarouselType.SQUARE_AD ||
                this.carouselType() === AdCarouselType.VERTICAL_AD
            ) {
                userPlugins.push(Fade());
            }

            this.emblaCarouselType = EmblaCarousel(
                this.emblaViewport.nativeElement,
                {
                    loop: true,
                    align: "start"
                },
                [
                    Autoplay({
                        delay: 5000,
                        stopOnInteraction: false,
                        stopOnMouseEnter: false,
                        stopOnFocusIn: false
                    }),
                    ...userPlugins
                ]
            );
        }
    }

    public ngOnDestroy(): void {
        if (this.emblaCarouselType) {
            this.emblaCarouselType.destroy();
        }
    }

    public scrollPrev(): void {
        this.emblaCarouselType?.scrollPrev();
    }

    public scrollNext(): void {
        this.emblaCarouselType?.scrollNext();
    }

    public openAd(ad: ItemsAds & { image: Files }): void {
        if (ad.url) {
            window.open(ad.url, "_blank");
        }
    }
}
